<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <!--ricerca -->
        <div class="card-title px-2 pt-2 pb-0 w-100">
          <div class="row">
            <div class="col-lg-3 col-12">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="search()" />
            </div>
            <div class="col-9 text-right" [ngClass.sm]="'col-12 mt-1'">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
              <a routerLink="/dashboard/customer/add" class="btn btn-outline-primary" *ngIf="this._authenticationService.hasCapability('create_customer')">{{ "ADD" | translate }}</a>
            </div>
          </div>
        </div>
        <!--desktop-->
        <div class="card-body p-0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 60 : 230"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filteredCustomers"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'COMPANY' | translate" prop="name" *ngIf="_utilService.isDesktop" [width]="90">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img #image (error)="image.hidden = true" (load)="image.hidden = false" src="{{ row.logo }}" class="mr-1" [alt]="row.name" width="32" height="32" />
                  <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                    <div class="avatar-content text-uppercase">{{ row.business_name[0] }}</div>
                  </div>
                  <a routerLink="/dashboard/customer/{{ row.id }}">{{ row.name }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'BUSINESS_NAME' | translate" prop="business_name" *ngIf="_utilService.isDesktop" [width]="300">
              <ng-template ngx-datatable-cell-template let-row="row">
                <p class="mb-0">{{ row.business_name }}</p>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'VAT_NUMBER' | translate" prop="vat_number" *ngIf="_utilService.isDesktop" [width]="80">
              <ng-template ngx-datatable-cell-template let-row="row">
                <p class="mb-0">{{ row.vat_number ? row.vat_number : "-" }}</p>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop" [width]="50">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="this._authenticationService.hasCapability('edit_customer')">
                    <a routerLink="/dashboard/customer/edit/{{ row.id }}" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </a>
                  </button>
                  <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" *ngIf="this._authenticationService.hasCapability('delete_customer')">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'COMPANY' | translate" prop="name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <div class="d-flex align-items-center">
                      <img #image (error)="image.hidden = true" src="{{ row.logo }}" class="mr-1 rounded-circle" [alt]="row.name" width="32" height="32" />
                      <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                        <div class="avatar-content text-uppercase">{{ row.business_name[0] }}</div>
                      </div>
                      <a routerLink="/dashboard/customer/{{ row.id }}">{{ row.name }}</a>
                    </div>
                    <div class="mt-1">
                      <p class="mb-0">{{ row.business_name }}</p>
                    </div>
                    <div>
                      <span>{{ "VAT_NUMBER" | translate }}: </span>
                      <span>{{ row.vat_number ? row.vat_number : "-" }}</span>
                    </div>
                    <div>
                      <span>{{ "BANK" | translate }}: </span>
                      <span>{{ row.bank_name ? row.bank_name : "-" }}</span>
                    </div>
                    <div>
                      <span>{{ "INVOICE_TYPE" | translate }}: </span>
                      <span>{{ row.invoice_type_name ? row.invoice_type_name : "-" }}</span>
                    </div>
                  </div>
                  <div class="col-12 mt-075 text-right" [ngClass.md]="'pr-2'">
                    <button class="bg-transparent border-0 text-secondary mb-1" *ngIf="this._authenticationService.hasCapability('edit_customer')">
                      <a routerLink="/dashboard/customer/edit/{{ row.id }}" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                        <i [data-feather]="'edit-2'" size="19"></i>
                      </a>
                    </button>
                    <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" *ngIf="this._authenticationService.hasCapability('delete_customer')">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
